import { FormattedMessage } from "react-intl";

const CrossProductInsights = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.crossProductInsights.content.body"
                    defaultMessage="Aggregate data from across your Atlassian toolchain for holistic insights that drive better decision making."
                />
            </p>
        </div>
    );
};

export default CrossProductInsights;
